module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append(escapeFn( locals.date ))
    ; __append(" <small class=\"text-muted d-none d-sm-inline-block\">")
    ; __append(escapeFn( locals.time ))
    ; __append("</small> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/item/headings/date_and_time/template.ejs
// module id = 1217
// module chunks = 1